// extracted by mini-css-extract-plugin
export var cartContainer = "_oc-4";
export var gray = "_oc-1";
export var itemContainer = "_oc-2";
export var itemDetails = "_oc-3";
export var strong = "_oc-0";